import { render, staticRenderFns } from "./allvip.vue?vue&type=template&id=4d702022&scoped=true&"
import script from "./allvip.vue?vue&type=script&lang=js&"
export * from "./allvip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d702022",
  null
  
)

export default component.exports